// Builder Components Registry for ISOcore CMS
import Heading from './Heading';
import Paragraph from './Paragraph';
import Image from './Image';
import Button from './Button';
import Hero from './Hero';
import Section from './Section';
import Container from './Container';
import Card from './Card';
import FeatureCard from './FeatureCard';
import Stats from './Stats';
import Testimonial from './Testimonial';
import FAQ from './FAQ';
import CTA from './CTA';
import ContactForm from './ContactForm';
import LogoCloud from './LogoCloud';

// Component registry with metadata
export const componentRegistry = {
  Heading,
  Paragraph,
  Image,
  Button,
  Hero,
  Section,
  Container,
  Card,
  FeatureCard,
  Stats,
  Testimonial,
  FAQ,
  CTA,
  ContactForm,
  LogoCloud,
};

// Get components organized by category
export const getComponentsByCategory = () => {
  return {
    'Layout': ['Section', 'Container'],
    'Content': ['Heading', 'Paragraph', 'Image', 'Hero'],
    'Components': ['Button', 'Card', 'FeatureCard', 'Stats', 'Testimonial', 'FAQ', 'CTA', 'ContactForm'],
    'Social Proof': ['LogoCloud'],
  };
};

export default componentRegistry;
